import {
  ExpandedDetailsSection,
  Flex,
  FlexColumn,
  FreshnessChart,
  TestLineageNavButton,
} from '@elementary/common-ui/components';
import {
  SourceFreshnessRunStatus,
  SourceFreshnessConfiguration,
  SourceFreshnessTestResult,
} from '@elementary/common-ui/types';
import AdditionalActionsButton from './AdditionalActionsButton';
import OpenTestRunsButton from './OpenTestRunsButton';

const SourceFreshnessExpandedRow = ({
  rowData,
  showWidgetButtons,
}: {
  rowData: SourceFreshnessTestResult;
  showWidgetButtons: boolean;
}) => {
  const { test_results: testResults, metadata } = rowData || {};
  const {
    warn_after: warnAfter,
    error_after: errorAfter,
    loaded_at_field: loadedAtField,
  } = metadata.configuration as SourceFreshnessConfiguration;

  if (
    testResults.max_loaded_at == null ||
    testResults.max_loaded_at_time_ago_in_s == null ||
    warnAfter == null ||
    errorAfter == null
  ) {
    return null;
  }
  return (
    <FlexColumn gap={2}>
      {showWidgetButtons && (
        <Flex gap={1} sx={{ alignSelf: 'flex-end' }}>
          <OpenTestRunsButton urlParam={metadata.elementary_unique_id} />
          {!!metadata.model_unique_id && (
            <TestLineageNavButton
              modelId={metadata.model_unique_id}
              testName={metadata.test_name}
            />
          )}
          <AdditionalActionsButton
            elementaryUniqueId={metadata.elementary_unique_id}
          />
        </Flex>
      )}
      <FreshnessChart
        lastTimestamp={testResults.max_loaded_at}
        status={metadata.latest_run_status as SourceFreshnessRunStatus}
        maxLoadedAtTimeAgoInSec={testResults.max_loaded_at_time_ago_in_s}
        warnAfterRange={warnAfter}
        errorAfterRange={errorAfter}
        loadedAtField={loadedAtField}
      />

      <ExpandedDetailsSection data={rowData} />
    </FlexColumn>
  );
};

export default SourceFreshnessExpandedRow;
